import styled from "styled-components";

export const Card = styled.div`
    width: 720px;
    padding-left: 10%;
    padding-right: 10%;
    padding-top: 3%;
    padding-bottom: 3%;
    border: 2px solid #DADADA;
    border-radius: 10px;
`;

export const LightBg = styled.div`
    font-family: Inter;
    padding: 75px 125px;
    background: #FFFFFF;
    font-family: 'Inter', sans-serif;

    @media screen and (max-width: 600px){
        padding: 75px 25px;
    };
`;